"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _PriceMatrixCell = _interopRequireDefault(require("./PriceMatrixCell"));
var PriceMatrixColumn = function PriceMatrixColumn(props) {
  var durationsObj = props.durationsObj,
    isTargetColumn = props.isTargetColumn,
    target = props.target,
    isMobile = props.isMobile;
  var columns = Object.entries(durationsObj);
  return /*#__PURE__*/_react["default"].createElement("div", null, columns.map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      duration = _ref2[0],
      day = _ref2[1];
    var full_price = day.full_price,
      link = day.link,
      price_coefficient = day.price_coefficient;
    var key = [full_price, link, duration].join('-');
    return /*#__PURE__*/_react["default"].createElement(_PriceMatrixCell["default"], {
      key: key,
      full_price: full_price,
      link: link,
      price_coefficient: price_coefficient,
      duration: duration,
      isMobile: isMobile,
      target: isTargetColumn ? target : undefined
    });
  }));
};
var _default = exports["default"] = PriceMatrixColumn;